var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayInfoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5576_9929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67802 8.74227C6.83122 8.74227 8.57674 6.99675 8.57674 4.84355C8.57674 2.69034 6.83122 0.944824 4.67802 0.944824C2.52481 0.944824 0.779297 2.69034 0.779297 4.84355C0.779297 6.99675 2.52481 8.74227 4.67802 8.74227Z",
    stroke: "#575757",
    strokeWidth: 1.16962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67871 6.40324V4.84375",
    stroke: "#575757",
    strokeWidth: 1.16962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67871 3.28418H4.68261",
    stroke: "#575757",
    strokeWidth: 1.16962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5576_9929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.35693,
    height: 9.35693,
    fill: "white",
    transform: "translate(0 0.165039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayInfoLogo);
export default __webpack_public_path__ + "static/media/gray-info-logo.20a7b05f68cf9a1bb1d75bc1762e77ab.svg";
export { ForwardRef as ReactComponent };